import * as React from 'react';
import PropTypes from 'prop-types';
import {Subbar, Title, SearchFilter, PageHeader} from "ah-tools";
import {translate} from "react-i18next";
import { List, ListItem} from "material-ui";
import moment from 'moment';
import {Button, Confirm, Dropdown, Icon, Label, Popup} from "semantic-ui-react";
import {DATE_FORMAT_FULL} from "../misc/vars";
import {ROUTE_ACCESS_CREATE, ROUTE_SERVICE_CREATE} from "../routes";
import {Link} from "react-router-dom";
import {LOC_ACCESS_LIST_OPIONS} from "../actions";
import Placeholder from "./Placeholder";
import {IconButton} from "../extensions";
// import SearchFilter from "../extensions/SearchFilter";
// import PageHeader from "../extensions/PageHeader";

const filterOptions = [
	{key: 'name', text: 'Name', value: 'name'},
	{key: 'email', text: 'E-Mail', value: 'email'},
	{key: 'id', text: 'ID', value: 'id'}
];

const sortOptions = [
	{key: 'name', text: 'Name', value: 'name'},
	{key: 'email', text: 'E-Mail', value: 'email'},
	{key: 'admin_id', text: 'ID', value: 'admin_id'},
	{key: 'logged_at', text: 'Login', value: 'logged_at'}
];

const sortByOptions = [
	{key: 'asc', text: <span><Icon name="sort content ascending"/> Aufsteigend</span>, value: 'asc'},
	{key: 'desc', text: <span><Icon name="sort content descending" /> Absteigend</span>, value: 'desc'}
];

const fromStorage = () => JSON.parse(window.localStorage.getItem(LOC_ACCESS_LIST_OPIONS)) || {sort: 'asc', sortBy: 'name', filter: '', filterBy: 'name'};

class AccessList extends React.Component {
	static propTypes = {
		admins: PropTypes.array.isRequired,
		isDeleting: PropTypes.func,
		onPush: PropTypes.func.isRequired,
		onDelete: PropTypes.func.isRequired,
		user_id: PropTypes.number,
		isLoading: PropTypes.bool
	};
	static defaultProps = {
		admins: [],
		isDeleting: () => false,
		onDelete: () => alert('onDelete() is not implemented!'),
		onPush: () => alert('onPush() is not implemented'),
		user_id: null,
		isLoading: false
	};
	state = {
		options: fromStorage(),
		_filter: {
			filter: '',
			filterBy: filterOptions[0].key
		},
		confirmDelete: null
	};
	setOption = (name, value) => this.setState(state => ({
		...state,
		options: {
			...state.options,
			[name]: value
		}
	}));
	_setFilter = (index, value) => this.setState(state => ({
		...state,
		_filter: {
			...state._filter,
			[index]: value
		}
	}));
	setFilter = (filter = '') => this._setFilter('filter', filter);
	setFilterBy = (filterBy = 'name') => this._setFilter('filterBy', filterBy);
	setSort = (sort = 'asc') => this.setOption('sort', sort);
	setSortBy = (sortBy = 'name') => this.setOption('sortBy', sortBy);
	
	filter = () => {
		let {filter, filterBy} = this.state._filter;
		filter = filter.trim().toLowerCase();
		if ( filter === '' ) {
			console.info('Filter is empty, returning all');
			return () => true;
		}
		
		switch (filterBy) {
			case 'email':
				return ({email}) => !!email.toLowerCase().match(filter);
			case 'id':
				return ({admin_id}) => !!(admin_id+'').toLowerCase().match(filter);
			default:
				console.info('should now return filter function by name');
				return ({name}) => !!name.toLocaleLowerCase().match(filter);
		}
	};
	
	sortString = (index) => this.state.options.sort === 'desc' ?
		(b,a) => a[index].toLowerCase().localeCompare(b[index].toLowerCase()) :
		(a,b) => a[index].toLowerCase().localeCompare(b[index].toLowerCase());
	
	sortNum = (index) => this.state.options.sort === 'desc' ?
		((a, b) => (a[index] || 0) < (b[index] || 0) ? 1 : -1) : ((a, b) => (a[index] || 0) < (b[index] || 0) ? -1 : 1);
	
	sort = () => {
		const {sortBy} = this.state.options;
		switch (sortBy) {
			case 'admin_id':
			case 'logged_at':
				return this.sortNum(sortBy);
			case 'email':
			case 'name':
				return this.sortString(sortBy);
			default:
				return this.sortString('name');
		}
	};
	
	setConfirmDelete = (callable=null) => this.setState(state => ({...state, confirmDelete: callable}));
	
	render() {
		const {admins, isDeleting, onDelete, user_id, isLoading, onPush} = this.props;
		const {options: {sort, sortBy}, _filter: {filter, filterBy}, confirmDelete} = this.state;
		const adminList = admins.filter(this.filter()).sort(this.sort());
		window.setTimeout(() => window.localStorage.setItem(LOC_ACCESS_LIST_OPIONS, JSON.stringify(this.state.options)), 0);
		if ( isLoading ) {
			return <Placeholder repeat={2} style={{marginTop: 50}}/>;
		}
		return (
			<div>
				<PageHeader align={Subbar.ALIGN_BETWEEN}>
					<Title style={{marginLeft: 10}}>Zugänge</Title>
					<Subbar align={Subbar.ALIGN_END}>
						<Button.Group style={{marginRight: 30}}>
							<Label>Sortierung</Label>
							<Dropdown button={true} options={sortOptions} value={sortBy} onChange={(_, data) => this.setSortBy(data.value)}/>
							<Dropdown button={true} options={sortByOptions} value={sort} onChange={(_, data) => this.setSort(data.value)}/>
						</Button.Group>
						<SearchFilter
							value={filter}
							onChange={value => this.setFilter(value)}
							selected={filterBy}
							options={filterOptions}
							onSelect={value => this.setFilterBy(value)}
						/>
						<Popup
							position={'left center'}
							inverted content={'Neuen Benutzer anlegen'}
							trigger={
								<IconButton onClick={() => onPush(ROUTE_ACCESS_CREATE)}><Icon name={'plus'} size={'large'}/></IconButton>
							}/>
					</Subbar>
				</PageHeader>
				<List style={{marginTop: 10}}>
					{adminList.map(admin => {
						const {admin_id, name, email, logged_at: timestamp} = admin;
						const deleting = isDeleting(admin_id);
						const logged_at = moment(timestamp).format(DATE_FORMAT_FULL);
						return (
							<ListItem
								style={{cursor: 'default'}}
								disableTouchRipple={true}
								disabled={deleting}
								key={`admin-${admin_id}`}
								primaryText={name}
								secondaryText={
									<Subbar>
										<strong style={{marginRight: 20}}>{admin_id}</strong>
										<span style={{marginRight: 20}}>{email}</span>
										<span>{logged_at}</span>
									</Subbar>
								}
								rightIconButton={
									user_id !== admin_id ?
										<IconButton onClick={() => this.setConfirmDelete(() => onDelete(admin_id, () => this.setConfirmDelete()))}>
											<Icon name={deleting ? 'spinner' : 'trash'} loading={deleting} disabled={deleting} size="large" />
										</IconButton> : null
								}
							/>
						);
					})}
				</List>
				<Confirm open={confirmDelete !== null} onConfirm={() => confirmDelete()} onCancel={() => this.setConfirmDelete()} cancelButton="Nein" confirmButton={"Ja"} content="Wirklich löschen?"/>
			</div>
		);
	}
}

// AccessList.propTypes = {};
// AccessList.defaultProps = {};

export default translate()(AccessList);



// WEBPACK FOOTER //
// ./src/components/AccessList.js